import React, { useContext, useEffect } from 'react';
import { LanguageContext } from "../context/LanguageContext";

const Topbar = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Topbar", "Topbar_lang"); // ✅ 確保 Topbar 只載入自己的語言檔案
  }, [language]);
  
  const LANGUAGE = componentLanguageData.Topbar || { Main: {} };
  return (
    <div className="container-fluid bg-dark px-5 d-none d-lg-block">
      <div className="row gx-0">
        {/* 左側資訊 */}
        <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
          <div className="d-inline-flex align-items-center" style={{ height: '45px' }}>
            <small className="me-3 text-light">
              <i className="fa fa-map-marker-alt me-2"></i>{LANGUAGE?.Main?.Content1}
            </small>
            <small className="me-3 text-light">
            {/* <a href={`tel:${LANGUAGE?.Main?.Content8}`}><i className="fa fa-phone-alt me-2"></i>{LANGUAGE?.Main?.Content2}</a> */}
            </small>
            <small className="text-light">
              <i className="fa fa-envelope-open me-2"></i>{LANGUAGE?.Main?.Content3}
            </small>
          </div>
        </div>
        {/* 右側語言切換按鈕 */}
        {/* 右側社交按鈕 */}
        {/* <div className="col-lg-4 text-center text-lg-end">
          <div className="d-inline-flex align-items-center" style={{ height: '45px' }}>
            <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter fw-normal"></i>
            </a>
            <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f fw-normal"></i>
            </a>
            <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in fw-normal"></i>
            </a>
            <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle"
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube fw-normal"></i>
            </a>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Topbar;